import React from "react";

function AuthModal({ open, onClose, onSignIn, onSignUp }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        {/* Close (X) */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-4 text-center">
          Welcome to MedMaze
        </h2>

        <p className="text-sm text-gray-600 mb-6 text-center">
          Sign in or sign up to book appointments, join waitlists, and set
          alerts.
        </p>

        <button
          type="button"
          onClick={onSignIn}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 mb-3"
        >
          Sign In
        </button>

        <div className="flex items-center my-3">
          <div className="flex-1 h-px bg-gray-200" />
          <span className="mx-2 text-gray-400 text-xs">or</span>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        <button
          type="button"
          onClick={onSignUp}
          className="w-full border border-blue-500 text-blue-600 py-2 px-4 rounded hover:bg-blue-50"
        >
          Sign Up
        </button>
      </div>
    </div>
  );
}

export default AuthModal;
